(() => {
  /* Adds the reassurance row to the review board. It is hidden below 990px by the stylesheet. */
  const items = [
    ['<path d="M3 6h11v11H3zM14 10h4l3 3v4h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>', 'Free tracked shipping worldwide'],
    ['<path d="M9 14 4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/>', '14-day returns, conditions apply']
  ];
  const build = () => {
    const tk = document.querySelector('.bzb__hero .bzb__tk');
    if (!tk || document.querySelector('.bzb__trust')) return;
    const list = document.createElement('ul');
    list.className = 'bzb__trust';
    list.setAttribute('aria-label', 'Why shop with confidence');
    items.forEach(([icon, text], i) => {
      const li = document.createElement('li');
      li.style.setProperty('--i', i);
      const mark = document.createElement('span');
      mark.className = 'bzb__trust-ico';
      mark.setAttribute('aria-hidden', 'true');
      mark.innerHTML = '<svg viewBox="0 0 24 24">' + icon + '</svg>';
      const label = document.createElement('span');
      label.textContent = text;
      li.append(mark, label);
      list.append(li);
    });
    tk.after(list);
  };
  build();
  document.addEventListener('DOMContentLoaded', build);
})();
